import clsx from "clsx"
import { SVGProps } from "react"
const AptelIcon = ({className = 'size-8',color, ...props}: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 45" className={clsx(className)} {...props}>
    <defs>
      <clipPath id="aptel">
        <path
          d="M8170-14814h42v45h-42z"
          data-name="Rectangle 8086"
        />
      </clipPath>
    </defs>
    <g
      clipPath="url(#aptel)"
      data-name="Mask Group 368"
      transform="translate(-8170 14814)"
    >
      <g className={color} data-name="Group 28737">
        <g data-name="Logo \u0622\u067E \u062A\u0644">
          <path
            d="M8183.088-14794.543c-.007.071.04.12.07.175a7.876 7.876 0 0 0 6.4 4.346 8.127 8.127 0 0 0 6.887-2.349 7.044 7.044 0 0 0 1.83-2.988 2.32 2.32 0 0 0-1.976-3.142 5.449 5.449 0 0 0-3.95.848 10.881 10.881 0 0 0-1.729 1.424c-.579.56-1.133 1.148-1.765 1.653a.731.731 0 0 1-.259.174.649.649 0 0 1-.084.088 4.357 4.357 0 0 1-3.935.621 4.659 4.659 0 0 1-1.489-.85Z"
            data-name="Path 15500"
          />
          <path
            d="M8183.087-14794.543a4.64 4.64 0 0 0 1.494.848 4.355 4.355 0 0 0 3.935-.621.646.646 0 0 0 .084-.088 8.442 8.442 0 0 1-1.554-.831 9.2 9.2 0 0 0-1.732-.908 3 3 0 0 0-1.6-.191 1.08 1.08 0 0 0-.653 1.753l.024.039Z"
            data-name="Path 15501"
            opacity={0.5}
          />
          <path
            d="M8201.601-14803.163c-.076-.008-.119.05-.17.089a14.983 14.983 0 0 0-1.344 1.217 16.97 16.97 0 0 1-2.051 1.824 5.863 5.863 0 0 1-3.834 1.123 2.992 2.992 0 0 1-1.966-.768 2.247 2.247 0 0 1-.6-2.313 7.013 7.013 0 0 1 1.891-3.231 8.156 8.156 0 0 1 5.216-2.454 8.56 8.56 0 0 1 5.593 1.3 8.3 8.3 0 0 1 2.864 3.2.486.486 0 0 1 .028.084c-.075.009-.12-.042-.171-.083a4.279 4.279 0 0 0-2.611-.943 4.166 4.166 0 0 0-2.22.517 1.931 1.931 0 0 0-.625.438Z"
            data-name="Path 15502"
          />
          <path
            d="M8201.6-14803.169a1.934 1.934 0 0 1 .623-.434 4.166 4.166 0 0 1 2.22-.517 4.278 4.278 0 0 1 2.611.943c.05.04.1.093.171.083-.013.024 0 .038.018.05a1.184 1.184 0 0 1 .173 1.218 1.075 1.075 0 0 1-.98.647 3.507 3.507 0 0 1-1.7-.308 10.382 10.382 0 0 1-1.451-.782c-.377-.232-.748-.474-1.143-.675a3.375 3.375 0 0 0-.542-.225Z"
            data-name="Path 15503"
            opacity={0.5}
          />
          <path
            d="M8190.629-14811.791c-.025 0-.038.016-.054.028a4.761 4.761 0 0 0-.43.39 5.453 5.453 0 0 1-.657.584 1.877 1.877 0 0 1-1.228.36.956.956 0 0 1-.63-.246.721.721 0 0 1-.193-.741 2.25 2.25 0 0 1 .606-1.035 2.613 2.613 0 0 1 1.671-.786 2.74 2.74 0 0 1 1.791.417 2.66 2.66 0 0 1 .917 1.026.169.169 0 0 1 .009.027c-.024 0-.038-.013-.055-.026a1.371 1.371 0 0 0-.836-.3 1.337 1.337 0 0 0-.711.166.6.6 0 0 0-.2.136Z"
            data-name="Path 15504"
          />
          <path
            d="M8190.628-14811.79a.625.625 0 0 1 .2-.139 1.332 1.332 0 0 1 .711-.166 1.371 1.371 0 0 1 .836.3c.016.013.031.03.055.026 0 .008 0 .012.006.016a.379.379 0 0 1 .055.39.344.344 0 0 1-.314.207 1.121 1.121 0 0 1-.543-.1 3.31 3.31 0 0 1-.465-.251c-.121-.074-.239-.152-.366-.216a1.2 1.2 0 0 0-.175-.067Z"
            data-name="Path 15505"
            opacity={0.5}
          />
          <path
            d="M8200.163-14794.537c.042-.061.016-.122 0-.185-.124-.623-.357-1.215-.526-1.825a4.093 4.093 0 0 1-.043-2.438 2.925 2.925 0 0 1 .633-1.132 1.4 1.4 0 0 1 2.079-.09 4.416 4.416 0 0 1 1.315 2.334 5.233 5.233 0 0 1-3.792 6.18 4.337 4.337 0 0 1-1.277.13 2.794 2.794 0 0 0 .871-.561 2.762 2.762 0 0 0 .821-1.882.817.817 0 0 0-.081-.531Z"
            data-name="Path 15506"
          />
          <path
            d="M8200.163-14794.537a.816.816 0 0 1 .086.533 2.767 2.767 0 0 1-.821 1.882 2.806 2.806 0 0 1-.871.561.675.675 0 0 1-.772-.946 2.051 2.051 0 0 1 .588-.79 7.112 7.112 0 0 1 1.064-.727 4.814 4.814 0 0 0 .726-.513Z"
            data-name="Path 15507"
            opacity={0.5}
          />
          <path
            d="M8190.944-14788.063a4.178 4.178 0 0 0 .708-.548c.3-.258.589-.527.91-.758a2.871 2.871 0 0 1 2.251-.566 1.2 1.2 0 0 1 1.071.9 1.308 1.308 0 0 1-.105.858 3.857 3.857 0 0 1-2.722 2.271 4.146 4.146 0 0 1-4.786-2.175c-.026-.054-.047-.11-.071-.164.017.005.038.005.05.016a2.089 2.089 0 0 0 1.16.538 2.056 2.056 0 0 0 1.534-.372Z"
            data-name="Path 15508"
          />
          <path
            d="M8190.948-14788.063a2.054 2.054 0 0 1-1.534.372 2.089 2.089 0 0 1-1.16-.538c-.012-.011-.033-.011-.05-.016a.751.751 0 0 1-.112-.28.518.518 0 0 1 .42-.626 1.446 1.446 0 0 1 .838.13 4.259 4.259 0 0 1 .788.461 4.971 4.971 0 0 0 .81.497Z"
            data-name="Path 15509"
            opacity={0.5}
          />
          <path d="m8198.179-14796.42.026-.043Z" data-name="Path 15510" />
          <path
            d="M8207.223-14802.966c-.021-.013-.033-.028-.02-.054a.038.038 0 0 1 .02.054Z"
            data-name="Path 15511"
          />
          <path d="M8186.899-14809.289Z" data-name="Path 15512" />
          <path
            d="M8187.405-14806.31c0-.291-.009-.584-.037-.882a7.921 7.921 0 0 0-.468-2.089 7 7 0 0 0-1.516-2.4 4.742 4.742 0 0 0-2.3-1.63 2.282 2.282 0 0 0-2.184.521 2.667 2.667 0 0 0-.621 1.693 5.29 5.29 0 0 0 .908 3.3 11.509 11.509 0 0 0 1.136 1.4 8.933 8.933 0 0 1 1.828 5.645 6.2 6.2 0 0 1-.085.643 6.115 6.115 0 0 1-.353 1.209l.459.459 1.561-.459s2.202-1.972 1.672-7.41Z"
            data-name="Path 15513"
            opacity={0.5}
          />
          <path
            d="M8182.389-14799.722c-.052.005-.082-.034-.117-.061a10.294 10.294 0 0 1-.924-.837 11.6 11.6 0 0 0-1.411-1.255 4.033 4.033 0 0 0-2.638-.773 2.055 2.055 0 0 0-1.353.528 1.547 1.547 0 0 0-.414 1.587 4.83 4.83 0 0 0 1.3 2.223 5.611 5.611 0 0 0 3.588 1.688 5.892 5.892 0 0 0 3.847-.894 5.71 5.71 0 0 0 1.97-2.2.348.348 0 0 0 .02-.058c-.052-.007-.083.029-.117.057a2.941 2.941 0 0 1-1.8.649 2.866 2.866 0 0 1-1.527-.356 1.335 1.335 0 0 1-.424-.298Z"
            data-name="Path 15514"
          />
          <path
            d="M8186.503-14805.476c.048.005.075-.032.107-.056a9.337 9.337 0 0 0 .848-.769 10.7 10.7 0 0 1 1.3-1.151 3.7 3.7 0 0 1 2.421-.709 1.888 1.888 0 0 1 1.242.485 1.419 1.419 0 0 1 .381 1.461 4.434 4.434 0 0 1-1.194 2.041 5.151 5.151 0 0 1-3.294 1.55 5.406 5.406 0 0 1-3.532-.821 5.252 5.252 0 0 1-1.809-2.024.375.375 0 0 1-.018-.053c.047-.006.076.026.108.052a2.706 2.706 0 0 0 1.649.6 2.626 2.626 0 0 0 1.4-.327 1.229 1.229 0 0 0 .391-.279Z"
            data-name="Path 15515"
          />
        </g>
        <g data-name="Group 26563">
          <path
            d="M8174.239-14777.395a3.774 3.774 0 0 0-3.769 3.769v3.639a.38.38 0 1 0 .76 0v-3.639a3.009 3.009 0 1 1 6.018 0v3.639a.38.38 0 1 0 .76 0v-3.639a3.773 3.773 0 0 0-3.769-3.769Z"
            data-name="Path 15532"
          />
          <path
            d="M8184.233-14777.395h-4.773a.38.38 0 0 0 0 .76h4.773a1.377 1.377 0 1 1 0 2.754h-4.773a.381.381 0 0 0-.38.38v3.514a.38.38 0 1 0 .76 0v-3.134h4.393a2.137 2.137 0 1 0 0-4.274Z"
            data-name="Path 15533"
          />
          <path
            d="M8194.307-14777.395h-6.488a.38.38 0 1 0 0 .76h2.864v6.648a.38.38 0 1 0 .76 0v-6.648h2.864a.38.38 0 0 0 0-.76Z"
            data-name="Path 15534"
          />
          <path
            d="M8202.584-14773.881h-6.233v-1.054a1.7 1.7 0 0 1 1.7-1.7h4.409a.38.38 0 1 0 0-.76h-4.409a2.462 2.462 0 0 0-2.46 2.46v2.87a2.462 2.462 0 0 0 2.46 2.46h4.409a.38.38 0 1 0 0-.76h-4.409a1.7 1.7 0 0 1-1.7-1.7v-1.05h6.232a.381.381 0 0 0 0-.761Z"
            data-name="Path 15535"
          />
          <path
            d="M8211.152-14770.367h-4.672a1.437 1.437 0 0 1-1.436-1.436v-5.212a.38.38 0 1 0-.76 0v5.213a2.2 2.2 0 0 0 2.2 2.2h4.672a.38.38 0 1 0 0-.76Z"
            data-name="Path 15536"
          />
        </g>
      </g>
    </g>
  </svg>
)
export default AptelIcon
